import React, { useEffect, useState } from "react";
import {
  resourceWidget,
  availability,
  availabilityText,
} from "../../components/common/Helper";
import {
  addToMyLibrary,
  removeFromFavorite,
} from "../../services/StudentHubService";
import Swal from "sweetalert2";
import { modalOpen, setFavouritesCount } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import ViewTextResource from "./ViewTextResource";
import { Link, useLocation } from "react-router-dom";
import { download } from "../../utils/FileDownload";
import moment from "moment";
import { BASE_URL, UPLOAD_ROOT_PATH } from "../../utils/Constants";
import { campusesWidget } from "../../components/common/Helper";
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function DigitalResourceDetail({ ResourceData, refreshData ,dropdownList }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [resourceIcon, setResourceIcon] = useState("");
  const [favIcon, setFavIcon] = useState("");
  const [campusData, setCampusData] = useState([]);
  const ResourceDetail = ResourceData.resourceDetails;
  const ResourceInformationDetails = ResourceData.ResourceInformationDetails;
  const favCount = useSelector((state) => state.favourites.favouritesCount);
    
  const wordSpliterTopics = (str, type) => {
    const strArr = Array.isArray(str.split(",")) ? str.split(",") : [];
    const newStrArr = strArr.length ? strArr?.map(item => {
    const topic = dropdownList && dropdownList?.topic && dropdownList?.topic.find(val => val.value == item);
      return item ? <small className="as-widget-resource" style={{color: '#fff',background: topic?.color}}>{topic?.label}</small> : '';      
    }) : "";
    return newStrArr;
  }
 
  useEffect(()=>{
    if(dropdownList.campus && dropdownList.campus.length){
      const campus = dropdownList.campus.find(item=>item.value==ResourceDetail?.campus)
      setCampusData(campus)
    }
  },[dropdownList])
  const addToLibrary = () => {
    if (!ResourceDetail?.favorite) {
      const data = { resource_id: ResourceDetail?.id };
      addToMyLibrary(data)
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: res.data.message,
            timer: 3000,
            onOpen: function () {
              Swal.showLoading();
            },
          }).then((result) => {
            dispatch(setFavouritesCount(favCount+1))
            refreshData();
          });
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Error",
          });
        });
    } else {
      const data = { resource_id: ResourceDetail?.id };
      removeFromFavorite(data)
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: res.data.message,
            timer: 3000,
            onOpen: function () {
              Swal.showLoading();
            },
          }).then((result) => {
            dispatch(setFavouritesCount(favCount-1))
            refreshData();
          });
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong!",
          });
        });
    }
  };

  const viewResource = () => {
    if (
      ResourceDetail?.type.toString().toLowerCase() === "vimeo" ||
      ResourceDetail?.type.toString().toLowerCase() === "youtube"
    ) {
      let link = `https://player.vimeo.com/video/${ResourceDetail?.video_id}`;
      if (ResourceDetail?.type.toString().toLowerCase() == "youtube") {
        link = ResourceDetail?.link;
      }
      dispatch(modalOpen(link));
    } else if (
      ResourceDetail?.type.toString().toLowerCase() === "article" ||
      ResourceDetail?.type.toString().toLowerCase() === "label"
    ) {
      setShow(true);
    }
  };

  useEffect(() => {
    let icon = "";
    switch (ResourceDetail?.type ? ResourceDetail.type.toLowerCase() : "") {
      case "link":
      case "white_paper":
        icon = "fad fa-link";
        break;
      case "video":
      case "vimeo":
      case "youtube":
        icon = "fad fa-video";
        break;
      case "book":
        icon = "fad fa-book";
        break;
      case "ebook":
        icon = "fad fa-wifi";
        break;
      case "document":
      case "pdf":
        icon = "fad fa-file";
        break;
      case "article":
        icon = "fad fa-newspaper";
        break;
      case "label":
        icon = "fad fa-tag";
        break;
    }
    setResourceIcon(icon);
    setFavIcon(ResourceDetail?.favorite ? "fas fa-star" : "fal fa-star");
  }, [ResourceDetail]);

  return (
    <>
      {show && (
        <ViewTextResource
          show={show}
          close={() => setShow(false)}
          data={ResourceDetail}
        />
      )}
      <div className="card card-profile-info-card">
        <div className="card-body advanced_serach d-flex mb-4">
          <div className="advanced_serach_left">
            {ResourceDetail?.thumbnail && ResourceDetail?.thumbnail != null ? (
              <figure>
                <LazyLoadImage
                    alt="Image Not Available"
                    effect="blur"
                    height={"100%"}
                    placeholderSrc={ResourceDetail.thumbnail.includes("http") ? ResourceDetail.thumbnail : (BASE_URL + "/" + ResourceDetail.thumbnail.replace(`${UPLOAD_ROOT_PATH}/`, "").replace("public/",""))}
                    src={ResourceDetail.thumbnail.includes("http") ? ResourceDetail.thumbnail : (BASE_URL + "/" + ResourceDetail.thumbnail.replace(`${UPLOAD_ROOT_PATH}/`, "").replace("public/",""))} 
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.remove();
                    }}
                />
              </figure>
            ) : (
              <div className="advanced_serach-img-box-2">
                <span className="serch-icon-upper">
                  <i class={resourceIcon}></i>
                </span>
              </div>
            )}
            <div
              className={`serach-btn-bottom d-flex justify-content-center ${
                ResourceDetail?.type.toString().toLowerCase() !== "book"
                  ? "mt-3"
                  : ""
              }`}
            >
              {ResourceDetail?.type === "link" ||
              ResourceDetail?.type === "white_paper" ||
              ResourceDetail?.type === "pdf" ||
              ResourceDetail?.type === "ebook" ? (
                <>
                  <a
                    href={
                      (ResourceDetail.link != null && ResourceDetail?.type === "link" )||
                     ( ResourceDetail?.type === "white_paper" && ResourceDetail.link != null)
                        ? ResourceDetail?.link :  ResourceDetail?.type === "pdf" && ResourceDetail.link != null ? ResourceDetail.link != null && ResourceDetail.link.includes("http") ? ResourceDetail.link : BASE_URL +
                        "/" +
                        ResourceDetail.link.replace(
                          `${UPLOAD_ROOT_PATH}/`,
                          ""
                        ).replace("public/","")
                        : ResourceDetail?.url
                    }
                    target="_blank"
                    className="btn btn-primary w-100"
                    title="View Resource"
                  >
                    <i className="fal fa-eye"></i> View Resource
                  </a>
                </>
              ) : ResourceDetail?.type.toString().toLowerCase() === "vimeo" ||
                ResourceDetail?.type.toString().toLowerCase() === "youtube" ? (
                <Link to={location.pathname + `/${ResourceDetail.type}/video`}>
                  <div
                    onClick={() => {
                      viewResource();
                    }}
                    className="btn btn-primary w-100"
                    title="View Resource"
                  >
                    <i className="fal fa-eye"></i> View Resource
                  </div>
                </Link>
              ) : ResourceDetail?.type.toString().toLowerCase() ===
                "book" ? null : (
                <button
                  type="button"
                  onClick={() => {
                    viewResource();
                  }}
                  className="btn btn-primary w-100"
                  title="View Resource"
                >
                  <i className="fal fa-eye"></i> View Resource
                </button>
              )}
            </div>
          </div>
          <div className="advanced_serach_right">
            <div className="advanced_serach_r-head d-flex justify-content-between mb-1">
              <div className="advanced_serach_r-head-left">
                {ResourceDetail?.type
                  ? resourceWidget(ResourceDetail?.type)
                  : "NA"}
              </div>
              <div className="advanced_serach_r-head-right d-flex">
                {ResourceDetail?.type === "pdf" && (
                  <button
                    onClick={() => {
                      const fileUrl = ResourceDetail.link.includes("http")
                        ? ResourceDetail.link
                        : `${BASE_URL}/${ResourceDetail.link
                          .replace(`${UPLOAD_ROOT_PATH}/`, "")
                          .replace("public/", "")}`;
                      
                      download(fileUrl, `${ResourceDetail?.title}.pdf`);
                    }}
                    className="btn btn-primary rounded-circle"
                    title="Download Resource"
                  >
                    <i className="fal fa-download"></i>
                  </button>
                )}
                <div className="as-buttons">
                  <button
                    onClick={() => {
                      addToLibrary();
                    }}
                    title="Favourites"
                    className="btn btn-primary rounded-circle"
                  >
                    <i className={favIcon}></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="advanced_serach_r-title_head">
            <h3 className="advanced_serach_r-title mb-3">
              {ResourceDetail?.title}
            </h3>
            <div className="advanced_serach_topic_r-head">
                {ResourceDetail?.topic
                  ? <div className="d-flex flex-wrap">
                    {wordSpliterTopics(ResourceDetail?.topic ? ResourceDetail?.topic.toString() : "")}
                  </div> 
                  : ""}
              </div>
            </div>
            {(ResourceDetail?.type === "link" ||
              ResourceDetail?.type === "white_paper") &&
              ResourceDetail?.link && (
                <a className="search-link-view mb-3">
                  <i class="fal fa-link"></i>{" "}
                  {(ResourceDetail?.type === "link" ||
                    ResourceDetail?.type === "white_paper") && (
                    <a
                      href={ResourceDetail?.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {ResourceDetail?.link ? ResourceDetail?.link : "NA"}
                    </a>
                  )}
                </a>
              )}

            <>
              {ResourceDetail?.sub_title && (
                <h4 className="advanced_serach_r-sub mb-3">
                  {ResourceDetail?.sub_title &&
                  (ResourceDetail?.sub_title).trim() !== ""
                    ? ResourceDetail?.sub_title
                    : "NA"}
                </h4>
              )}
              <ul className="seacrh_list-info">
                {ResourceDetail?.author && (
                  <li>
                    {" "}
                    <i class="fal fa-user"></i>
                    {ResourceDetail?.author}
                  </li>
                )}
                {(ResourceDetail?.type == "book" ||
                  ResourceDetail?.type == "Book" || ResourceDetail?.type == "ebook") && ResourceDetail?.language && (                  
                  <li className="normal-font-weight">
                    <i class="fal fa-globe"></i>
                    {ResourceDetail?.language}
                  </li>
                )}
              </ul>
            </>
            {ResourceDetail?.description &&
              (ResourceDetail?.description).trim() !== "" && (
                <h4 className="advanced_serach_r-sub mb-3">Description</h4>
              )}
            {ResourceDetail?.description &&
              (ResourceDetail?.description).trim() !== "" && (
                <p className="search_descripton">
                  {ResourceDetail?.description &&
                  (ResourceDetail?.description).trim() !== ""
                    ? ResourceDetail?.description
                    : "NA"}
                </p>
              )}
          </div>
        </div>
        {(ResourceDetail?.type == "book" || ResourceDetail?.type == "Book" || ResourceDetail?.type == "ebook") && (
            <div className="card card-profile-info-card">
              <div className="card-body ">
                <div className="card-header pt-0">Information</div>
                <div className="card-body-inr">
                  <div className="box-list-style-box">
                    <ul>
                      {ResourceDetail.publisher && <li>
                        <span>Publisher:</span> {ResourceDetail.publisher}
                      </li>}                                            
                      {ResourceDetail?.dewey && <li>
                        <span>Dewey Nr:</span> {ResourceDetail?.dewey}
                      </li>}                                            
                      {ResourceDetail.barcode && <li>
                        <span>Barcode:</span> {ResourceDetail.barcode}
                      </li>}
                      {ResourceDetail?.isbn && <li>
                        <span>ISBN:</span> {ResourceDetail?.isbn}
                      </li>}
                      {ResourceDetail.series && <li>
                        <span>Series:</span> {ResourceDetail.series}
                      </li>}
                      {ResourceDetail?.type != "ebook" && campusData?.color && campusData?.label && <>
                      <li>
                        <span>Campus:</span>{" "}
                        {campusesWidget(campusData?.color,campusData?.label)}
                      </li>
                      {ResourceDetail.availability && <li>
                        <span>Availability:</span>{" "}
                        <span
                        title={availabilityText(ResourceDetail.availability)}
                        >
                          {availability(ResourceDetail.availability)}
                        </span>
                      </li>}
                      </>}
                      {ResourceDetail.availability == "issued" && ResourceInformationDetails?.due_date && <li>
                        <span>Return Date:</span> {moment.unix(ResourceInformationDetails?.due_date).format("DD MMM YY")}
                      </li>}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>
    </>
  );
}
